import {
	AttachAvailabilitySessionPhotoMutation,
	RemoveItemAvailabilityPhotoMutation,
	SetItemAvailabilityPhotoPrimaryMutation
} from "~/gql/mutations/availability.generated";
import { GetItemAvailabilityQuery } from "~/gql/queries/availability.generated";

export const availabilityEndpoints = {
	AttachAvailabilitySessionPhoto: {
		invalidatesTags: ["Availability"] as AddTagTypes,
		transformResponse: (res: AttachAvailabilitySessionPhotoMutation) => res
	},
	RemoveItemAvailabilityPhoto: {
		invalidatesTags: ["Availability"] as AddTagTypes,
		transformResponse: (res: RemoveItemAvailabilityPhotoMutation) => res
	},
	SetItemAvailabilityPhotoPrimary: {
		invalidatesTags: ["Availability"] as AddTagTypes,
		transformResponse: (res: SetItemAvailabilityPhotoPrimaryMutation) => res
	},
	GetItemAvailability: {
		providesTags: ["Availability"] as AddTagTypes,
		transformResponse: (res: GetItemAvailabilityQuery) => res
	}
};
